import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';
import { z } from 'zod';
import { parseUrlParam } from '~/components/Filter';

const KIND_SCHEMA = z.array(z.enum(['EVENT', 'MANUAL']));
const EVENT_TYPE_SCHEMA = z.array(z.string());
const ACTION_SCHEMA = z.array(
  z.enum([
    'PLAY_OVERLAY',
    'PLAY_SHOW',
    'STOP_OVERLAY',
    'TRIGGER_VIEW',
    'TUNE_CHANNEL',
    'TV_OFF',
    'TV_ON',
  ]),
);
const TAGS_SCHEMA = z.array(z.string());

export const getSignalFiltersParams = (searchParams: URLSearchParams) => ({
  action: parseUrlParam(
    () => ACTION_SCHEMA.parse(JSON.parse(searchParams.get('action') || '[]')),
    'action',
  ),
  eventType: parseUrlParam(
    () => EVENT_TYPE_SCHEMA.parse(JSON.parse(searchParams.get('eventType') || '[]')),
    'eventType',
  ),
  kind: parseUrlParam(
    () => KIND_SCHEMA.parse(JSON.parse(searchParams.get('kind') || '[]')),
    'kind',
  ),
  tags: parseUrlParam(
    () => TAGS_SCHEMA.parse(JSON.parse(searchParams.get('tags') || '[]')),
    'tags',
  ),
});

export const useSignalFiltersParams = () => {
  const [searchParams] = useSearchParams();
  const [_, setSavedParamsString] = useLocalStorage('device-signals:filters', '');

  // Save to local storage whenever URL params change
  useEffect(() => {
    setSavedParamsString(() => searchParams.toString());
  }, [searchParams, setSavedParamsString]);

  return getSignalFiltersParams(searchParams);
};
